import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '@vds/theme';
import { BodyConfig, TypographyConfig } from '@vds/typography';
import { Toggle as CoreToggle } from '@vds-core/toggles';
var propTypes = {
  /**
   * If provided, the toggle will be rendered in the inverted state.
   */
  inverted: PropTypes.bool
};

var Toggle = function Toggle(props) {
  function _calculateBackgroundColor(disabled, on, inverted) {
    if (disabled && inverted) {
      return colors.coolGray10;
    } else if (disabled && !inverted) {
      return colors.coolGray3;
    } else if (!disabled && inverted && !on) {
      return colors.coolGray6;
    } else if (on) {
      return colors.green;
    } else {
      return colors.black;
    }
  }

  function _calculateTextColor(disabled, on, inverted) {
    if (disabled && inverted) {
      return colors.coolGray6;
    } else if (disabled && !inverted) {
      return colors.coolGray1;
    } else {
      return colors.white;
    }
  }

  function _calculateButtonColor(disabled, inverted) {
    if (disabled && inverted) {
      return colors.coolGray6;
    } else if (disabled && !inverted) {
      return colors.coolGray1;
    } else {
      return colors.white;
    }
  }

  return /*#__PURE__*/React.createElement(CoreToggle, _extends({}, props, {
    hitArea: true,
    focusState: true,
    size: "large",
    typescale: TypographyConfig.getTypescale(),
    calculateFontWeight: 700,
    bodyConfig: BodyConfig,
    colorConfig: colors,
    calculateTextColor: _calculateTextColor,
    calculateButtonColor: _calculateButtonColor,
    calculateBackgroundColor: _calculateBackgroundColor
  }));
};

Toggle.propTypes = propTypes;
export default Toggle;